import { render } from "./brain_logo.vue?vue&type=template&id=679ac9ca&scoped=true"
import script from "./brain_logo.vue?vue&type=script&lang=js"
export * from "./brain_logo.vue?vue&type=script&lang=js"

import "./brain_logo.vue?vue&type=style&index=0&id=679ac9ca&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679ac9ca"]])

export default __exports__